import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import { ProductImage } from 'audamatic-ui';
import Link from '../../base_link/component';
import './styles/styles.scss';

class BannerCoverflow extends Component {
  get products() {
    return (this.props.products || []).slice(0, 5);
  }

  get title() {
    return this.props.title || null;
  }

  get subtitle() {
    return this.props.subtitle || null;
  }

  get text() {
    return this.props.text || null;
  }

  get url() {
    return this.props.url || '#';
  }

  render() {
    return (
      <Link href={this.url} className="coverflow">
        <div className="coverflow-media">
          <div className="coverflow-media-content">
            {this.products.map((product, i) => {
              const _product = new Product(product);
              return (
                <div className="image wrapper product-image-wrapper" key={`cf-${i}`}>
                  <ProductImage
                    product={_product}
                    maxHeight={308}
                  />
                </div>
              );
            })
            }
          </div>
        </div>

        <div className="coverflow-content">
          {!!this.subtitle &&
            <p className="coverflow-subtitle">{this.subtitle}</p>
          }
          {!!this.title &&
            <p className="coverflow-title">{this.title}</p>
          }
          {!!this.text &&
            <p className="coverflow-text">{this.text}</p>
          }
        </div>

      </Link>
    );
  }
}

BannerCoverflow.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array,
  subtitle: PropTypes.string,
  url: PropTypes.string,
  text: PropTypes.string,
};

export default BannerCoverflow;
